// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"39818258","207":"ff0098e0","292":"d4f5bc0e","332":"126d3875","396":"6d8d6cfa","416":"0d6131ad","666":"21189eef","676":"f9bf24bc","732":"6e6e19a8","791":"e3e49b3a","844":"7ecb1451","933":"e095be3f"}[chunkId] + ".chunk.js";
};